import React from 'react';
export function RefundsPage() {
  return <div className="min-h-screen bg-[#faf8f6] py-12 md:py-20" data-id="element-371">
      <div className="max-w-4xl mx-auto px-6" data-id="element-372">
        <h1 className="text-4xl md:text-5xl font-serif text-[#2d2d2d] mb-8" data-id="element-373">
          Política de Reembolsos y Devoluciones
        </h1>

        <div className="prose prose-lg max-w-none text-[#5a5a5a] space-y-6" data-id="element-374">
          <p className="text-sm text-[#8b6f6f]" data-id="element-375">
            Última actualización:{' '}
            {new Date().toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
          </p>

          <section data-id="element-376">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-377">
              Garantía de Satisfacción de 30 Días
            </h2>
            <p data-id="element-378">
              Estamos comprometidos con su satisfacción. Si no está
              completamente satisfecho con su compra de "El Divorcio Emocional",
              puede solicitar un reembolso completo dentro de los 30 días
              posteriores a la fecha de compra.
            </p>
          </section>

          <section data-id="element-379">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-380">
              Condiciones para Reembolsos
            </h2>
            <p data-id="element-381">
              Para ser elegible para un reembolso, debe cumplir con las
              siguientes condiciones:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-382">
              <li data-id="element-383">
                La solicitud debe realizarse dentro de los 30 días posteriores a
                la compra
              </li>
              <li data-id="element-384">
                Debe proporcionar el número de pedido o la dirección de correo
                electrónico utilizada en la compra
              </li>
              <li data-id="element-385">
                Debe explicar brevemente el motivo de su insatisfacción
                (opcional pero apreciado para mejorar nuestros productos)
              </li>
            </ul>
          </section>

          <section data-id="element-386">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-387">
              Cómo Solicitar un Reembolso
            </h2>
            <p data-id="element-388">Para solicitar un reembolso, siga estos pasos:</p>
            <ol className="list-decimal pl-6 space-y-3" data-id="element-389">
              <li data-id="element-390">
                <strong data-id="element-391">Contacte con soporte:</strong> Envíe un correo
                electrónico a nuestro equipo de soporte con el asunto "Solicitud
                de Reembolso"
              </li>
              <li data-id="element-392">
                <strong data-id="element-393">Proporcione información:</strong> Incluya su número de
                pedido, dirección de correo electrónico de compra y motivo del
                reembolso
              </li>
              <li data-id="element-394">
                <strong data-id="element-395">Confirmación:</strong> Recibirá una confirmación de
                recepción de su solicitud dentro de 24-48 horas
              </li>
              <li data-id="element-396">
                <strong data-id="element-397">Procesamiento:</strong> Su reembolso se procesará dentro
                de 5-7 días hábiles
              </li>
            </ol>
          </section>

          <section data-id="element-398">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-399">
              Método de Reembolso
            </h2>
            <p data-id="element-400">
              Los reembolsos se procesarán utilizando el mismo método de pago
              que utilizó para la compra original:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-401">
              <li data-id="element-402">
                <strong data-id="element-403">Tarjeta de crédito/débito:</strong> El reembolso
                aparecerá en su estado de cuenta dentro de 5-10 días hábiles
              </li>
              <li data-id="element-404">
                <strong data-id="element-405">PayPal:</strong> El reembolso se acreditará en su cuenta
                de PayPal dentro de 3-5 días hábiles
              </li>
              <li data-id="element-406">
                <strong data-id="element-407">Otros métodos:</strong> Los tiempos pueden variar según
                el procesador de pagos
              </li>
            </ul>
          </section>

          <section data-id="element-408">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-409">
              Productos Digitales
            </h2>
            <p data-id="element-410">
              Dado que "El Divorcio Emocional" es un producto digital, no hay
              devoluciones físicas. Una vez procesado el reembolso, se espera
              que elimine todas las copias del material descargado.
            </p>
          </section>

          <section data-id="element-411">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-412">
              Excepciones
            </h2>
            <p data-id="element-413">No se otorgarán reembolsos en los siguientes casos:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-414">
              <li data-id="element-415">Solicitudes realizadas después de 30 días de la compra</li>
              <li data-id="element-416">Violación de nuestros Términos y Condiciones</li>
              <li data-id="element-417">
                Uso indebido del producto o intento de distribución no
                autorizada
              </li>
              <li data-id="element-418">Compras realizadas a través de terceros no autorizados</li>
            </ul>
          </section>

          <section data-id="element-419">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-420">
              Cancelaciones
            </h2>
            <p data-id="element-421">
              Dado que el acceso al producto es inmediato tras la compra, no es
              posible cancelar un pedido una vez completado. Sin embargo, puede
              solicitar un reembolso dentro del período de garantía de 30 días.
            </p>
          </section>

          <section data-id="element-422">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-423">
              Problemas Técnicos
            </h2>
            <p data-id="element-424">
              Si experimenta problemas técnicos con la descarga o acceso al
              producto:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-425">
              <li data-id="element-426">Contacte primero con nuestro equipo de soporte técnico</li>
              <li data-id="element-427">Intentaremos resolver el problema dentro de 24-48 horas</li>
              <li data-id="element-428">
                Si no podemos resolver el problema, se le ofrecerá un reembolso
                completo
              </li>
            </ul>
          </section>

          <section data-id="element-429">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-430">
              Disputas
            </h2>
            <p data-id="element-431">
              Si tiene alguna disputa sobre un cargo, le recomendamos que se
              comunique con nosotros primero antes de iniciar una disputa con su
              banco o procesador de pagos. Estamos comprometidos a resolver
              cualquier problema de manera justa y rápida.
            </p>
          </section>

          <section data-id="element-432">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-433">
              Cambios en esta Política
            </h2>
            <p data-id="element-434">
              Nos reservamos el derecho de modificar esta política de reembolsos
              en cualquier momento. Los cambios entrarán en vigor inmediatamente
              después de su publicación en el sitio web. Las compras realizadas
              antes de cualquier cambio estarán sujetas a la política vigente en
              el momento de la compra.
            </p>
          </section>

          <section data-id="element-435">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-436">
              Contacto
            </h2>
            <p data-id="element-437">
              Si tiene preguntas sobre nuestra Política de Reembolsos y
              Devoluciones, puede contactarnos a través de nuestro correo
              electrónico de soporte. Nuestro equipo está disponible para
              ayudarle y responderá a su consulta lo antes posible.
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-[#d4a5a5]/30" data-id="element-438">
          <a href="/" className="text-[#9d4b6b] hover:text-[#8b6f6f] transition-colors font-medium" data-id="element-439">
            ← Volver a la página principal
          </a>
        </div>
      </div>
    </div>;
}